import { faCloudExclamation, faWandMagicSparkles } from '@fortawesome/pro-light-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WizardErrorPage } from '@partful/features/instructions/ui/WizardErrorPage';
import { Button } from '@partful/shared/ui/Button';
import { ErrorBody } from '@services/productInventory';
import { useTranslation } from 'react-i18next';
import { useCancelPartsCategoriesJob } from '../lib/hooks/useCancelPartsCategoriesJob';
import { usePartsCategoriesForm } from '../lib/hooks/usePartsCategoriesForm';
import { ErrorList } from './ErrorList';
import styles from './PartsCategoriesFailed.module.scss';

interface PartsCategoriesFailedProps {
  accountId: string;
  runID: string;
  errors: ErrorBody[] | null;
}

export function PartsCategoriesFailed({ accountId, runID, errors }: PartsCategoriesFailedProps) {
  const { t } = useTranslation('manageProduct');

  const { cancelJob } = useCancelPartsCategoriesJob();
  const { resetForm } = usePartsCategoriesForm();

  const retryUpload = async () => {
    resetForm();
    await cancelJob(accountId, runID);
  };

  return (
    <WizardErrorPage
      errorIcon={<FontAwesomeIcon icon={faCloudExclamation} />}
      errorTitle={
        <>
          <FontAwesomeIcon icon={faWandMagicSparkles} /> {t('partsCategories.processingPage.failure.ranIntoError')}{' '}
        </>
      }
      errorMessage={<ErrorList runID={runID} errors={errors} />}
      errorActions={
        <Button className={styles.uploadButton} onClick={() => retryUpload()}>
          {t('partsCategories.processingPage.failure.uploadANewFile')}
        </Button>
      }
    />
  );
}
